import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { IGetState } from '../../../../../../../types/types';
import { root } from '../../../../../../../store/constants';
import { getQualificationTemplateBoardIds } from '../selectors/getQualificationTemplateBoardIds';
import { createFirstBoard } from '../../../../../../../rest/effects/board/createFirstBoard';
import {
    authUserSetFirstTemplateBoard
} from '../../../../../../../rest/effects/authUser/authUserSetFirstTemplateBoard';
import { segmentTrackAction, SegmentUserEvent } from '../../../../../../../middlewares/segment';
import {
    IGNORE_FIRST_TEMPLATE_RESET_SESSIONSTORAGE
} from '../../../../../../../rest/effects/board/boardResetFirstTemplateBoardIfNeeded';
import { getActiveBoardId } from '../../../../../../../store/model/selectors/getActiveBoardId';

export const onGetStarted = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        // игнориуем первый раз в создании доски
        sessionStorage.setItem(IGNORE_FIRST_TEMPLATE_RESET_SESSIONSTORAGE, JSON.stringify(true));
        dispatch(segmentTrackAction(SegmentUserEvent.GET_STARTED_CLICKED));
        root.App.controller.mainView.qualificationDialog.remove();
        const qualificationTemplateBoardIds = getQualificationTemplateBoardIds(getState());
        if (qualificationTemplateBoardIds && qualificationTemplateBoardIds.length === 1) {
            dispatch(createFirstBoard(qualificationTemplateBoardIds[0]));
        } else if (qualificationTemplateBoardIds && qualificationTemplateBoardIds.length > 1) {
            root.App.controller.mainView.showTemplateSelectDialog();
        } else { // если скипнули, то грузим Quick Start
            dispatch(createFirstBoard());
        }
        root.App.controller.mainView.doAfterLoader(() => {
            if (qualificationTemplateBoardIds && qualificationTemplateBoardIds.length > 1) return;
            dispatch(authUserSetFirstTemplateBoard(getActiveBoardId(getState())));
        });
    };
    return action;
};
